import colors from '../colors'

const overlay = {
  color: colors.rt.black,
  opacity: 0.6,
}

export default overlay
